<template>
  <div>
    <v-stepper v-model="currentStep" vertical>
      <v-stepper-step
        :color="appButtonColor"
        :complete="step > 1"
        step="1"
      >Online Service E-Sign Disclosure and Consent</v-stepper-step>
      <v-stepper-content step="1">
        <consent id="consent" />
      </v-stepper-content>
      <v-stepper-step
        :color="appButtonColor"
        :complete="step > 2"
        step="2"
      >Terms of Use - {{ mersBranded ? 'My MERS' : 'My Alerus' }}</v-stepper-step>
      <v-stepper-content step="2">
        <div v-if="mersBranded">
          <mersTerms id="print" />
        </div>
        <div v-else>
          <terms id="print" />
        </div>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>
<script>
import VueHtmlToPaper from "@/plugins/print";
import Terms from "@/components/Terms.vue";
import MersTerms from "@/components/MersTerms.vue";
import Consent from "@/components/Consent.vue";
import { mapState } from "vuex";
export default {
  name: "privacy",
  components: {
    Terms,
    MersTerms,
    Consent,
  },
  created() {},
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["step", "mersBranded"]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
    currentStep: {
      get() {
        return this.step;
      },
      set(step) {},
    },
  },
  mixins: [VueHtmlToPaper],
  methods: {},
};
</script>
<style lang="scss">
.v-stepper__label {
  font-size: 1.5rem;
}
button.v-btn__content {
  text-transform: capitalize;
}
</style>
